import React from 'react';
import PropTypes from 'prop-types';
import {getWidgetValues} from "sportinglife-react-common/widgets";
import Ooyala from "../../../Ooyala/component/Ooyala";
import withErrorBoundary from "../../../Errors/components/withErrorBoundry";

const OoyalaEmbed = ({widget, bodyVisible}) => {
  const {content_id} = getWidgetValues(widget, ["content_id"]);
  return bodyVisible && <Ooyala contentId={content_id}/>
};

OoyalaEmbed.mapProps = (props) => ({
  bodyVisible: props.bodyVisible,
  widget: props.widget
})
OoyalaEmbed.propTypes = {
  bodyVisible: PropTypes.bool,
  widget: PropTypes.object
}

export default  withErrorBoundary(OoyalaEmbed);



// WEBPACK FOOTER //
// ./modules/News/components/widgets/OoyalaEmbed.widget.js